import PermissionFilterPanel from 'src/Admin/components/User/Permissions';
const PermissionSelection = ({
  setSendToPermissionDataHandler,
  formFields,
}) => {
  const onSelectedPermissionsCount = (length) => {
    console.log('length', length);
  };

  const onSelectedPermissionLists = (value) => {
    setSendToPermissionDataHandler(value);
  };
  const onSetAllPermissions = (value) => {
    console.log('all select value', value);
  };
  return (
    <div>
      <h2 className="blob-permission-plan-section-heading mt-4">Permissions</h2>
      <PermissionFilterPanel
        createUserFormData={formFields}
        onSelectedPermissionsCount={onSelectedPermissionsCount}
        onSelectedPermissionLists={onSelectedPermissionLists}
        onSetAllPermissions={onSetAllPermissions}
        editMode={true}
      />
    </div>
  );
};

export default PermissionSelection;
